/* eslint-disable @typescript-eslint/no-explicit-any */
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { useField } from 'formik';
import React from 'react';
import { ClassicEditor, Editor, PluginConstructor } from 'ckeditor5';
import { DEFAULT_EDITOR_CONFIG } from 'Containers/Teleconsult/Main/AINotes/editorConfig';

import FieldLayout from '../FieldLayout/FieldLayout';

import styles from './CkEditorField.less';

export interface CkeditorFieldProps {
  name: string;
  label?: string | React.ReactNode;
  autofocus?: boolean;
  inline?: boolean;
  isUploading?: boolean;
  wrapStyles?: React.CSSProperties;
  toolbar?: {
    items: string[];
  };
  disabled?: boolean;
  plugins?: Array<PluginConstructor<Editor> | string>;
}

function CkEditorField({
  name,
  label,
  autofocus = false,
  inline,
  wrapStyles,
  toolbar,
  disabled,
  plugins,
}: Readonly<CkeditorFieldProps>) {
  const [field, meta, helpers] = useField(name);
  const isError = meta.touched && meta.error !== undefined;

  return (
    <FieldLayout isError={isError} inline={inline} label={label} errorMessage={meta?.error}>
      <div className={styles.wrapHtmlEditor} style={wrapStyles}>
        <CKEditor
          config={{
            ...DEFAULT_EDITOR_CONFIG,
            toolbar: toolbar ?? DEFAULT_EDITOR_CONFIG.toolbar,
            plugins: plugins ?? DEFAULT_EDITOR_CONFIG.plugins,
          }}
          editor={ClassicEditor}
          data={field.value ?? ''}
          onBlur={() => {
            helpers.setTouched(true);
          }}
          disabled={disabled}
          onChange={(event: any, editor) => {
            const data = editor.getData();
            // data = handleMarkdownOutput(data);
            helpers.setValue(data);
          }}
          onReady={editor => {
            if (autofocus) editor?.editing?.view?.focus();
          }}
        />
      </div>
    </FieldLayout>
  );
}
export default CkEditorField;
